import { ReactNode } from 'react';

import { loadFullHeaderStaticProps } from '@toctoc/design-system';
import TocTocLayout from './layout';
import { iLayoutProps } from '@/components/templates/menu/view/menu.interfaces';

export async function loadLayoutStaticProps(): Promise<Partial<iLayoutProps>> {
	const BASE_HEADER = process.env.URL_BASE_HEADER ? process.env.URL_BASE_HEADER : ""
	const servicesDefinition = await import('services.setup.server');
	const { setupServices } = servicesDefinition; 
	const services = setupServices();
	const headerStaticProps = await loadFullHeaderStaticProps({
		fetch,
		baseUrl: BASE_HEADER
	});

	const footerData = await services.getFooterData();
	return {
		headerStaticProps,
		footerData
	};
}

export function getPersonasLayout(page: ReactNode, layoutData: iLayoutProps) {
	return (
		<TocTocLayout
			containerClassName="styles.container"
			{...layoutData}
			activeMenu="personas"
		>
			{page}
		</TocTocLayout>
	);
}

export default getPersonasLayout
